import request from '@utils/request'
import store from '@/store/index'
const comApi = {
  GetWebFile(key_no, f_src, callback) {
    let _this = this
    let url = 'fileUp.ashx?action=GetWebFile'
    request.post(url, {
      KEY_NO: key_no,
      F_SRC: f_src
    }).then(res => {
      res.forEach(item => {
        // item.url = item.URL
        let url = item.URL.indexOf('http') != -1 ? item.URL : store.getters.getFileRoot + item.URL
        item.url = item.src = item.msrc = url
        item.name = item.FILE_NAME
      })
      typeof callback == 'function'
      callback(res)
    })
  },
  SaveWebFile(doc_no, f_src, files, callback) {
    let url = 'fileUp.ashx?action=SaveFile'
    let fileArr = []
    files.forEach(item => {
      fileArr.push({
        F_SRC: f_src,
        DOC_NO: doc_no,
        FILE_DNM: item.name,
        FILE_UNM: item.URL
      })
    })
    request.post(url, {
      DOC_NO: doc_no,
      F_SRC: f_src,
      WEBFILE_INFO: JSON.stringify(fileArr)
    }).then(res => {
      typeof callback == 'function'
      callback(true)
    })
  }
}
export default comApi



// WEBPACK FOOTER //
// ./src/utils/comapi.js